import React from 'react';

export type ButtonVariant = 
  | 'primary' 
  | 'primary-filled' 
  | 'secondary' 
  | 'success' 
  | 'success-filled' 
  | 'warning' 
  | 'warning-filled' 
  | 'danger' 
  | 'danger-filled' 
  | 'purple' 
  | 'purple-filled';

export type ButtonSize = 'sm' | 'base' | 'lg' | 'xl';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  isIcon?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'base',
  fullWidth = false,
  isIcon = false,
  className = '',
  children,
  disabled,
  ...props
}) => {
  const getVariantClass = () => {
    return `btn-${variant}`;
  };

  const getSizeClass = () => {
    if (isIcon) {
      switch (size) {
        case 'sm':
          return 'btn-icon-sm';
        case 'lg':
          return 'btn-icon-lg';
        case 'xl':
          return 'btn-icon-lg';
        default:
          return 'btn-icon';
      }
    }
    
    switch (size) {
      case 'sm':
        return 'btn-sm';
      case 'lg':
        return 'btn-lg';
      case 'xl':
        return 'btn-xl';
      default:
        return '';
    }
  };

  const classes = [
    getVariantClass(),
    getSizeClass(),
    fullWidth ? 'btn-full' : '',
    disabled ? 'btn-disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}; 